import { render, staticRenderFns } from "./AssetBand.vue?vue&type=template&id=60a078be&scoped=true&"
import script from "./AssetBand.vue?vue&type=script&lang=js&"
export * from "./AssetBand.vue?vue&type=script&lang=js&"
import style0 from "./AssetBand.vue?vue&type=style&index=0&id=60a078be&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a078be",
  null
  
)

export default component.exports